// ========================
// === Formatting money ===
// ========================
var formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// ==================================
// === Ajax cart refresh function ===
// ==================================
// Add delegated event listeners for quantity controls, delete buttons, and close button
// Add delegated event listeners for quantity controls, delete buttons, and close button
function setupDelegatedCartListeners() {
    document.body.addEventListener('click', async (event) => {
        console.log(event.target); // Log the clicked element

        // Handle quantity control buttons
        if (event.target.matches('.quantity-controls button')) {
            event.preventDefault();
            const button = event.target;
            const isIncrease = button.classList.contains('quantity-increase');
            const rootItem = button.closest('.cart-item');
            const quantityInput = rootItem.querySelector('input[name="quantity"]');
            let newQuantity = parseInt(quantityInput.value);

            // Adjust the quantity
            newQuantity = isIncrease ? newQuantity + 1 : newQuantity - 1;

            // Update or remove item based on new quantity
            if (newQuantity < 1) {
                await removeItemFromCart(rootItem.dataset.lineItemKey, rootItem);
            } else {
                await updateCartItemQuantity(rootItem.dataset.lineItemKey, newQuantity);
            }
            await refreshCart();
        }

        // Handle item delete buttons
        if (event.target.matches('.cart-item-delete') || event.target.closest('.cart-item-delete')) {
            console.log('Delete clicked!'); // Log delete action
            event.preventDefault();
            const button = event.target.closest('.cart-item-delete'); // Get the closest delete button
            const rootItem = button.closest('.cart-item');
            await removeItemFromCart(rootItem.dataset.lineItemKey, rootItem);
            await refreshCart();
        }

        // Handle cart close button
        if (event.target.matches('#cartCloseBtn') || event.target.closest('#cartCloseBtn')) {
            console.log('Cart close button clicked!'); // Log close button click
            event.preventDefault();
            toggleCartMenu(); // Close the cart menu
        }

        // Handle mobile menu close button
        if (event.target.matches('#mobileMenuCloseBtn') || event.target.closest('#mobileMenuCloseBtn')) {
            console.log('Mobile menu close button clicked!'); // Log mobile menu close click
            event.preventDefault();
            const mobileMenu = document.getElementById('mobileMenu');
            mobileMenu.classList.remove('open'); // Close the mobile menu
            document.body.classList.remove('no-scroll'); // Remove no-scroll class if needed
        }

        // Handle opening the order note popup
        if (event.target.matches('#addOrderNoteButton') || event.target.closest('#addOrderNoteButton')) {
            console.log('Add order note button clicked!');
            event.preventDefault();
            const orderNoteFormContainer = document.querySelector(".order-note-form-container");
            orderNoteFormContainer.classList.add("open"); // Show the popup
        }

        // Handle closing the order note popup and saving the note
        if (event.target.matches('#noteCloseBtn') || event.target.closest('#noteCloseBtn')) {
            console.log('Note close button clicked!');
            event.preventDefault();
            const cartNoteTextarea = document.getElementById("CartNote");
            const noteContent = cartNoteTextarea.value; // Get the note content

            // Save the note to the cart
            saveNoteToCart(noteContent);

            // Close the popup
            const orderNoteFormContainer = document.querySelector(".order-note-form-container");
            orderNoteFormContainer.classList.remove("open");

            // Update the button text based on note content
            const addOrderNoteButton = document.getElementById("addOrderNoteButton");
            addOrderNoteButton.textContent = noteContent.trim() === '' ? 'Add note' : 'Edit note';

            // Show or hide the preview container based on note content
            const notePreviewContainer = document.querySelector(".order-note-preview-container");
            if (noteContent.trim() === '') {
                // Hide the preview container if there's no content
                notePreviewContainer.style.display = 'none';
            } else {
                // Display the preview container and set the note content
                notePreviewContainer.style.display = 'block';
                notePreviewContainer.textContent = noteContent.length > 65 ? noteContent.slice(0, 65) + '...' : noteContent;
            }
        }
    });

// Function to save note to the cart
function saveNoteToCart(note) {
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ note })
    })
    .then(response => response.json())
    .then(data => {
        console.log("Cart updated with note:", data);
    })
    .catch(error => {
        console.error("Error updating cart with note:", error);
    });
}

    // Blur event for manual quantity input
    document.body.addEventListener('blur', async (event) => {
        if (event.target.matches('.quantity-controls input[name="quantity"]')) {
            const input = event.target;
            const rootItem = input.closest('.cart-item');
            let newQuantity = parseInt(input.value);

            if (newQuantity < 1 || isNaN(newQuantity)) {
                await removeItemFromCart(rootItem.dataset.lineItemKey, rootItem);
            } else {
                await updateCartItemQuantity(rootItem.dataset.lineItemKey, newQuantity);
            }
            await refreshCart();
        }
    }, true); // Use capture phase for blur
}

// Function to update the quantity of an item in the cart
async function updateCartItemQuantity(itemKey, newQuantity) {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
            id: itemKey,
            quantity: newQuantity
        })
    });
}

// Function to remove an item from the cart
async function removeItemFromCart(itemKey, cartItemElement) {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
            id: itemKey,
            quantity: 0 // Setting quantity to 0 removes the item
        })
    });
}

// Updating the cart drawer and reapplying animations
async function updateCartDrawer() {
    const res = await fetch('/?section_id=cart-drawer');
    const text = await res.text();

    const html = document.createElement('div');
    html.innerHTML = text;
    document.querySelector('#cartMenu').innerHTML = html.querySelector('#cartMenu').innerHTML;

    loadLottieAnimation();
}

// Refresh the cart by updating the cart drawer and details
async function refreshCart() {
    await updateCartDrawer();
    updateCartDetails();
}

// Ajax adding to cart
document.addEventListener("DOMContentLoaded", () => {
    setupDelegatedCartListeners();

    // Handle Ajax add-to-cart form submissions
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
        form.addEventListener('submit', async (event) => {
            event.preventDefault();
            await fetch('/cart/add', { method: 'POST', body: new FormData(form) });
            await refreshCart();
        });
    });
});

function updateCartDetails() {
    // Fetch the cart data from cart.js
    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            const cartItemCount = data.item_count;
            const basketCounterElement = document.querySelector('.basket-counter');

            if (cartItemCount === 0) {
                if (basketCounterElement) {
                    basketCounterElement.style.opacity = '0'; // Set opacity to 0
                    basketCounterElement.textContent = '0';
                }
            } else {
                if (basketCounterElement) {
                    basketCounterElement.textContent = cartItemCount;
                    basketCounterElement.style.opacity = '1'; // Ensure opacity is 1
                }
            }

            // Extract the subtotal value from the cart data
            const subtotalInPennies = data.total_price;
            // Format the subtotal value into pounds
            const subtotalInPounds = (subtotalInPennies / 100).toFixed(2);
            // Update the HTML content of the subtotal element
            const subtotalContainer = document.querySelector('.cart-subtotal');
        })
        .catch(error => console.error('Error retrieving cart data:', error));
}

// Toggle cart menu visibility and scroll behavior
function toggleCartMenu(event) {
    event?.stopPropagation();
    event?.preventDefault();
    
    const cartItemCount = document.querySelector('.basket-counter').textContent; // Get the item count
    const cartMenu = document.getElementById('cartMenu');
    const body = document.body;

    if (cartItemCount > 0) { // Check if item count is greater than zero
        if (cartMenu.classList.toggle('open')) {
            body.classList.add('no-scroll');
        } else {
            body.classList.remove('no-scroll');
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const cartButton = document.getElementById('cartButton');
    const burgerButton = document.getElementById('burgerButton');
    const mobileMenu = document.getElementById('mobileMenu');
    const burgerLines = document.querySelectorAll('.burger-line');
    const overlays = document.querySelectorAll('#overlay'); // Select all overlay elements
    const cartMenu = document.getElementById('cartMenu');
    const body = document.body;

    function closeMenus() {
        cartMenu.classList.remove('open');
        mobileMenu.classList.remove('open');
        burgerButton.classList.remove('cross');
        burgerLines.forEach(line => line.classList.remove('cross'));
        body.classList.remove('no-scroll');
    }

    function toggleCartMenu(event) {
        event.stopPropagation();
        event.preventDefault();
    
        // Close burger menu if open
        if (mobileMenu.classList.contains('open')) {
            closeMenus();
        }
    
        const cartMenu = document.getElementById('cartMenu');
        const body = document.body;
        const cartItemCount = document.querySelector('.basket-counter').textContent; // Get the item count
    
        if (cartMenu.classList.contains('open')) {
            // If the cart is open, just close it
            cartMenu.classList.remove('open');
            body.classList.remove('no-scroll');
        } else {
            // If the cart is closed, check item count
            if (cartItemCount > 0) { // Check if item count is greater than zero
                cartMenu.classList.add('open');
                body.classList.add('no-scroll');
            }
        }
    }

    function toggleBurgerMenu(event) {
        event.stopPropagation();
        event.preventDefault();

        // Close cart menu if open
        if (cartMenu.classList.contains('open')) {
            closeMenus();
        }

        // Toggle burger menu visibility
        mobileMenu.classList.toggle('open');
        burgerButton.classList.toggle('cross');
        burgerLines.forEach(line => line.classList.toggle('cross'));

        body.classList.toggle('no-scroll', mobileMenu.classList.contains('open'));
    }

    // Add click event listener to each overlay to close menus
    overlays.forEach(overlay => {
        overlay.addEventListener('click', () => {
            if (cartMenu.classList.contains('open') || mobileMenu.classList.contains('open')) {
                closeMenus();
            }
        });
    });

    // Toggle cart and burger menus
    cartButton.addEventListener('click', toggleCartMenu);
    burgerButton.addEventListener('click', toggleBurgerMenu);
});


// ========================
// === Collapsable text ===
// ========================
document.addEventListener('DOMContentLoaded', function() {
  const collapsibles = document.querySelectorAll(".collapsible");

  collapsibles.forEach(function(collapsible) {
    const trigger = collapsible.querySelector("h2, h3");
    const content = collapsible.querySelector(".content");

    trigger.addEventListener("click", function() {
        // Collapse all other sections
        collapsibles.forEach(function(otherCollapsible) {
            if (otherCollapsible !== collapsible) {
                otherCollapsible.classList.remove("active");
                otherCollapsible.querySelector(".content").style.height = 0;
            }
        });

        // Toggle the current section
        collapsible.classList.toggle("active");
        if (collapsible.classList.contains("active")) {
            content.style.height = content.scrollHeight + "px";
        } else {
            content.style.height = 0;
        }
      });
  });
});


// ==================================
// === Add to cart tick animation ===
// ==================================
document.addEventListener("DOMContentLoaded", function() {
    // Counter element
    const basketCounter = document.querySelector('.basket-counter');

    // Select all the 'add-to-basket' buttons on the page
    const addToBasketButtons = document.querySelectorAll('#product-add-to-basket');

    // Add click event listener to each 'add-to-basket' button
    addToBasketButtons.forEach(function(addToBasketButton) {
        addToBasketButton.addEventListener('click', function(event) {
            const basketIcon = document.querySelector('.basket-counter');
            let counter = parseInt(basketCounter.textContent) || 0;

            // Create a new div for the tick
            const tick = document.createElement('div');
            tick.classList.add('product-tick-container');
            tick.innerHTML = '<div class="product-tick"></div>';
            document.body.appendChild(tick);

            // Use fixed positioning for the tick
            tick.style.position = 'fixed';
            tick.style.left = (event.clientX - 17) + 'px'; // Center horizontally based on viewport
            tick.style.top = (event.clientY - 12) + 'px';  // Center vertically based on viewport
            tick.style.zIndex = '9999';

            // Get the basket icon's position relative to the viewport
            const basketRect = basketIcon.getBoundingClientRect();
            const deltaX = basketRect.left - event.clientX + 15;
            const deltaY = basketRect.top - event.clientY + 9;

            // Animate the tick towards the basket
            setTimeout(() => {
                const quantityInput = document.getElementById("quantity");
                const quantity = parseInt(quantityInput.value); // Parse the value as an integer

                tick.style.transition = 'transform 0.75s cubic-bezier(0.795, 0.065, 0.815, 0.985)';
                tick.style.transform = `translate(${deltaX}px, ${deltaY}px)`;

                setTimeout(() => {
                    // Increment counter and update counter display
                    counter += quantity;
                    basketCounter.textContent = counter;
                    basketIcon.style.opacity = '1';
                }, 700);

                // After animation, remove the tick
                setTimeout(() => {
                    tick.remove();
                }, 1200);
            }, 200);
        });
    });
});


// ==================================
// === rotated class alternations ===
// ==================================
// Select all elements with class 'rotated'
const rotatedElements = document.querySelectorAll('.rotated');

// Options for the IntersectionObserver
const options = {
    root: null, // use the viewport as the root
    threshold: 0.5 // trigger when 50% of the element is visible
};

// Callback function to be executed when an observed element is intersecting
const intersectionCallback = (entries, observer) => {
    entries.forEach(entry => {
        // Check if the element is intersecting (i.e., visible)
        if (entry.isIntersecting) {
            // Apply rotation class with a delay based on the index of the element
            const index = parseInt(entry.target.dataset.index); // assuming you set a data-index attribute

            setTimeout(() => {
                if (index % 2 === 0) {
                    entry.target.classList.add('rotate-left');
                } else {
                    entry.target.classList.add('rotate-right');
                }
            }, 500); // Delay of 500 milliseconds (0.5 seconds)

            // Once rotated, no need to observe this element further
            observer.unobserve(entry.target);
        }
    });
};

// Create a new IntersectionObserver
const observer = new IntersectionObserver(intersectionCallback, options);

// Iterate over each rotated element and observe them
rotatedElements.forEach((element, index) => {
    // Store the index using a data attribute for use in the callback
    element.dataset.index = index;
    // Start observing each element
    observer.observe(element);
});


document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent the default anchor behavior

        const target = document.querySelector(this.getAttribute('href'));

        // Set offset based on screen width
        const offset = window.innerWidth <= 870 ? 0 : 0;

        if (target) {
            window.scrollTo({
                top: target.offsetTop - offset,
                behavior: 'smooth'
            });

            // Optionally update URL without hash
            // history.pushState({}, '', window.location.pathname + window.location.search);
        }
    });
});

